import { observer } from 'mobx-react';
import React from 'react';
import PropTypes from 'prop-types';

import { Settlement, Layout, HardwareAPI } from 'tplus-components-touch';
import { PosInitData, TStore } from 'tplus-poslogin';
import { serverLog } from 'tplus-api';
import { stores, env, nativeMs, localStore as localStoreMs } from 'mutants-microfx';

import VoucherTpl from '../components/voucherPosTouch';
import VoucherLefter from '../components/voucherLeftPosTouch';
import VoucherPattern from '../components/voucherPatternPosTouch/index';
import Model from '../components/modalWraperPosTouch';
import Product from '../components/product'
import Drawer from '../components/drawer'

import { action, toJS } from 'mobx';
import { injectViewModel } from 'mutants-appfx';

import { voucherStateStore } from '../pageStores'
import setData from '../config/setData.js'
import debounce from 'lodash/debounce'
import localStore from '../localStore'
import { DataSource } from '../commom/Enum.js'

import _throttle from 'lodash/throttle'
import UiCommon from '../util/uiCommon.js'
import envPlatform from '../util/env.js'
import './style.less'

const { Footer, Sider, Content } = Layout;

@injectViewModel('Voucher')
@observer
class RetailOrderView extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            voucherDefaultPosMode: {},
            pageId: Date.now(),
            underAmountThreshold: false
        }
        const { controllerEvent } = this.props
        this.controllerEvent = controllerEvent;
        const horizontalPad = envPlatform.horizontalPad();
        this.horizontalSunMi = envPlatform.horizontalSunMi();
        this.resizeThrottled = _throttle(this.resize, 100);
        this.amountThreshold = horizontalPad ? 860 : 1024;
        this.isMobileEnvironment = horizontalPad;
        this.hasElectron = env.platform === env.constant.platform.electron;
        this.openWeightParams = {} //电子秤数据
    }

    static contextTypes = {
        router: PropTypes.object,
        onEvent: PropTypes.func,
        onAction: PropTypes.func,
        stores: PropTypes.object,
        infoRender: PropTypes.func,
        headHook: PropTypes.object,
        viewModel: PropTypes.object
    }
    static propTypes = {
        match: PropTypes.object
    }

    componentWillMount() {
        this.guide = {};
        const { headHook: { addClass } = {} } = this.context;
        addClass && addClass(this.state.pageId, 'retailOrder');
        voucherStateStore.init();
        // 进入开单页的默认焦点
        let config = this.getCursorDefaultPosition();
        if (config && config.cursorDefault) {
            localStoreMs && localStoreMs.set('cursorDefaultPosition', config.cursorDefault)
        }
        // 辨别触摸屏模式、单据模式，并保存
        this.voucherDefaultPosMode = localStoreMs && localStoreMs.get('voucherDefaultPosMode') || 'touch';
    }
    componentDidMount() {
        setTimeout(async () => {
            this.setMemberProductCursor();
            //获取硬件设置参数
            await stores.hardSetStore.getHardwareSetting()
            if (!!this.horizontalSunMi) {
                await this.openSunMiScale();
                return;
            }
            await this.openScale();
            await this.openGuestShow();
        }, 0)
        this.resize();
        window.addEventListener('resize', this.resizeThrottled)
    }

    componentWillUnmount() {
        const { headHook: { removeClass } = {} } = this.context
        removeClass && removeClass(this.state.pageId, 'retailOrder');
        //练习收银清空挂单数据
        if (voucherStateStore.mode === 'practice') {
            localStore.leavePracticePage();
        }

        //清除右上角导购员
        this.context.infoRender(<span></span>)

        //关闭电子秤、客显
        voucherStateStore.changeScaleState({ state: '0' })
        voucherStateStore.changeGuestShowState({ state: '0' })
        if (this.hasElectron === true) {
            const portsetting_hardSet = stores.hardSetStore;
            if (portsetting_hardSet && portsetting_hardSet.scale_enable) {
                console.log('关闭电子秤参数:', this.openWeightParams)
                nativeMs.setIpcRendererMethod('CloseWeight', this.openWeightParams);
            }
            if (portsetting_hardSet && portsetting_hardSet.guestshow_enable) {
                HardwareAPI.closeCusDisp({ isClearTPB: true }, ret => {
                    let dt = JSON.parse(ret);
                    if (dt && dt.status === 0) {
                        console.log('关闭客显成功')
                    }
                })
            }
        }
        window.removeEventListener('resize', this.resizeThrottled)
    }

    resize = () => {
        let _this = this;
        const width = document.body.clientWidth;
        this.setState({ underAmountThreshold: width <= _this.amountThreshold })
    }

    // 打开商米电子秤
    async openSunMiScale() {
        voucherStateStore.changeScaleState({ state: '0' });
        /* 是否进行电子秤设置 */
        const portsetting_hardSet = stores.hardSetStore;
        console.log("portsetting_hardSet:", portsetting_hardSet)
        if (!portsetting_hardSet || !portsetting_hardSet.scale_enable) {
            voucherStateStore.changeScaleState({ state: '2' })
            console.log("进入开单页打开电子秤，无portsetting_hardSet参数 state设置为2", voucherStateStore.scaleState)
            return;
        }
        return;
    }

    /* 打开电子秤 */
    async openScale() {
        voucherStateStore.changeScaleState({ state: '0' })
        if (this.hasElectron === false) {
            voucherStateStore.changeScaleState({ state: '1' })
            console.log("进入开单页打开电子秤，不在客户端环境 state设置为1", voucherStateStore.scaleState)
            return;
        }
        /* 是否进行电子秤设置 */
        const portsetting_hardSet = stores.hardSetStore;
        console.log("portsetting_hardSet:", portsetting_hardSet)

        if (!portsetting_hardSet || !portsetting_hardSet.scale_enable) {
            voucherStateStore.changeScaleState({ state: '2' })
            console.log("进入开单页打开电子秤，无portsetting_hardSet参数 state设置为2", voucherStateStore.scaleState)
            return;
        }
        /* 电子称数据 */
        const { scale_baud, scale_check, scale_bit, scale_stop, scale_type, scale_port } = portsetting_hardSet;
        if (!scale_port || !scale_type) {
            console.warn(`电子秤参数有误:scale_port:${scale_port};scale_type:${scale_type}`);
            return;
        }
        let openWeightParams = {
            port: scale_port,
            setting: `${scale_baud},${scale_check},${scale_bit},${scale_stop}`,
            balance: scale_type,
            onlyOpen: true
        }
        this.openWeightParams = openWeightParams;
        console.log(openWeightParams, '打开电子秤所需参数')
        nativeMs.setIpcRendererMethod('OpenWeight', openWeightParams, async (ret) => {
            const dt = JSON.parse(ret);
            if (!dt || dt.intace === 0) {
                voucherStateStore.changeScaleState({ state: '3' })
                console.log("进入开单页打开称，获取值失败 state设置为3", voucherStateStore.scaleState)
            }
            console.log('电子秤启动流程结束')
        })
        console.log("电子open完成  voucherStateStore：", voucherStateStore.scaleState)
    }

    /* 打开客显 */
    async openGuestShow() {
        voucherStateStore.changeGuestShowState({ state: '0' })
        if (this.hasElectron === false) {
            voucherStateStore.changeGuestShowState({ state: '1' })
            console.log("进入开单页打开客显，不在客户端环境 state设置为1", voucherStateStore.guestShowState)
            return;
        }
        /* 是否进行客显设置 */
        const portsetting_hardSet = stores.hardSetStore;
        console.log("portsetting_hardSet:", portsetting_hardSet)

        if (!portsetting_hardSet || !portsetting_hardSet.guestshow_enable) {
            voucherStateStore.changeGuestShowState({ state: '2' })
            console.log("进入开单页打开客显，无portsetting_hardSet参数 state设置为2", voucherStateStore.guestShowState)
            return;
        }
        /* 客显称数据 */
        const { guestshow_type, guestshow_port, guestshow_params } = portsetting_hardSet;
        let openGuestShowParams = {
            dev: guestshow_type,
            port: 'com' + guestshow_port,
            portset: guestshow_params
        }
        console.log('打开客显所需参数', openGuestShowParams)
        HardwareAPI.openCusDisp(openGuestShowParams, ret => {
            let dt = JSON.parse(ret);
            if (dt && dt.error) {
                voucherStateStore.changeGuestShowState({ state: '3' })
                console.log("进入开单页打开称，获取值失败 state设置为3", voucherStateStore.guestShowState)
            }
            console.log('客显启动流程结束')
        })
    }

    /* 默认商品录入焦点位置 */
    setInventoryFocus(){
        this.controllerEvent('setInventoryFocus');
    }

    /* 默认参数设置焦点位置 */
    setMemberProductCursor(){
        this.controllerEvent('setMemberProductCursor');
    }

    getProductConfigure() {
        let { setStore } = this.context.stores;
        let productConfigure = {};
        let typeSet = {}, configure = {};
        let data = toJS(setStore.getSetData())
        if (Array.isArray(data)) {//接口数据为数组
            configure = setData.getProductConfigure(data)
            typeSet = setData.getInventoryButtonSize(data)
        }
        productConfigure = {
            configure,
            ...typeSet
        }
        return productConfigure;
    }

    getCursorDefaultPosition() {
        let { setStore } = this.context.stores;
        let configure = {}
        let data = toJS(setStore.getSetData())
        if (Array.isArray(data)) {//接口数据为数组
            configure = setData.getCursorDefaultPosition(data)
        }
        return configure;
    }
    @action addSku = (product, x, y, el) => {
        //设置位置 用于购物车抛物线
        voucherStateStore.changeInventoryPosition({ x, y });
        voucherStateStore.changeEl(el)
        //触发添加商品controller
        this.controllerEvent('addInventory', { inventory: product });
    }

    @action justOneResultCallBack = (data) => {
        if (window.__successModal) {
            window.__successModal.destroy()
            window.__successModal = null
        }
        this.controllerEvent('justOneResultCallBack', data);

    }

    /* 结算成功回调 */
    @action onSettleSuccess({ openCashBox }) {
        //用户信息
        const userId = PosInitData('UserId');
        const userName = PosInitData('UserName');
        const userParams = JSON.stringify({ userId, userName });
        try {
            let _this = this;
            serverLog('newretail', { eventId: 'SettleSuccessProcess_onSettleSuccess_trigger_printRetail', param: userParams });
            this.controllerEvent('printRetail', { openCashBox }).then(() => { // 先打印然后重新开单
                serverLog('newretail', { eventId: 'SettleSuccessProcess_onSettleSuccess_trigger_clearVoucherData', param: userParams });
                _this.controllerEvent('clearVoucherData', { keep: true });
            })
        } catch (error) {
            serverLog('newretail', { eventId: 'SettleSuccessProcess_onSettleSuccess_error', param: userParams });
        }
    }
    /* 取消结算 */
    onCancelSettle() {
        this.controllerEvent('cancelPromotion', true);
    }

    /* 特定报错 重新开单 */
    @action clearVoucherData = () => {
        this.controllerEvent('clearVoucherData');
    }

    /* 结算校验 */
    onValidate = () => {
        UiCommon.mask({});
        // 需要异步校验
        let _this = this;
        return new Promise((resolve, reject) => {
            _this.controllerEvent('onValidate').then(() => {
                UiCommon.deleteMask({ async: true });
                resolve(this.props.viewModel.settlementVisiable);
            }).catch((err) => {
                console.warn(err)
                UiCommon.deleteMask({ async: true });
            })
        });
    }

    /* 权限校验 */
    authorityValidate = ({callback})=>{
        const {controllerEvent} = this.props;
        UiCommon.mask({});
        // 需要异步校验
        let _this = this;
        return new Promise((resolve, reject)=>{
          _this.controllerEvent('authorityValidate').then((result)=>{
            UiCommon.deleteMask({async:true});
            callback && callback(result)
            resolve(result);
          }).catch((err)=>{
            console.warn(err)
            UiCommon.deleteMask({async:true});
          })
        });
    }

    onCollapse = (collapsed) => {
        this.setState({ collapsed });
    }

    render() {
        const { collapsed, underAmountThreshold } = this.state;
        const { mode } = voucherStateStore;
        let voucherVM = this.props.viewModel;
        let dataModal = voucherVM.store.data;
        let isReturn = dataModal.IdbusiType === 35;
        let IdMember = dataModal.Idmember || '';
        const storeInfo = TStore.restore()
        const idStore = storeInfo.storeID;
        const voucherMode = this.voucherDefaultPosMode == 'voucher';
        
        /* 结算参数 */
        let settlementParams = {};
        let bTest = (mode === 'practice');
        console.log(DataSource, 'DataSource==')
        settlementParams = {
            bTest: bTest,
            onValidate: this.onValidate,
            onSettleSuccess: ({ openCashBox }) => {
                setTimeout(() => $.observerTrigger(), 0)
                this.onSettleSuccess({ openCashBox })
            },
            onCancelSettle: () => {
                setTimeout(() => $.observerTrigger(), 0)
                this.onCancelSettle()
                this.setInventoryFocus()
            },
            onModalClose: () => {
                this.setMemberProductCursor()
            },
            clearVoucherData: this.clearVoucherData,
            onHandleAmount: async (type) => {
                await this.controllerEvent('getAvailableAmount', { type })
            },
            dataSource: DataSource,
            initData: PosInitData,
            storeInfo: storeInfo,
            showAmount: (voucherMode && underAmountThreshold) ? true : !underAmountThreshold,
            amount: dataModal.TotalTaxAmount,
            totalVariety: voucherVM.totalVariety,
            totalQuantity: voucherVM.totalQuantity,
            quantityDetail: voucherVM.quantityDetail,
            isReturn: isReturn,
            isShowChangeTurn: true
        }

        /* 选商品参数 */
        let productParams = {};
        const productConfigure = this.getProductConfigure();
        let totalAmount = this.context && this.context.viewModel && this.context.viewModel.data.TotalTaxAmount;
        let { quantityDetail: { buyQuantity = 0, returnQuantity = 0 }, totalVariety, totalQuantity } = voucherVM || {};
        //数量总和的值，包括称重的。
        let sumQuantity = 0;
        let sumRetailDetails = this.context && this.context.viewModel && this.context.viewModel.data.RetailDetails;
        if (sumRetailDetails && sumRetailDetails.length > 0) {
            sumRetailDetails.forEach(v => {
                sumQuantity += Math.abs(v.Quantity);
            })
        }
        productParams = {
            configure: {
                ...productConfigure.configure,
                idStore: idStore
            },
            type: productConfigure.type,
            onClick: debounce(this.addSku, 50),
            justOneResultCallBack: this.justOneResultCallBack,
            isReturn: isReturn,
            idMember: IdMember,
            showAmount: this.state.underAmountThreshold,
            pricePrecision: PosInitData("PricePrecision"),
            totalAmount: totalAmount,
            totalVariety: totalVariety,
            totalQuantity: totalQuantity,
            buyQuantity: buyQuantity,
            returnQuantity: returnQuantity,
            sumQuantity:sumQuantity,
        }

        /*会员*/
        let memberParams = {
            selectMemberSuccess: () => {
                this.controllerEvent('setInventoryFocus')
            },
            authorityValidate: this.authorityValidate
        }

        //渲染导购员
        if (voucherVM && voucherVM.guide && voucherVM.guide.ID !== this.guide.ID) {
            this.guide = voucherVM.guide;
            if (!voucherVM.guide.ID) {
                this.context.infoRender(<span></span>)
            } else {
                var renderText = this.guide.Name
                this.context.infoRender(<span className='voucher-head-guide' style={{ isplay: 'inline-block', marginRight: '20px' }}>导购员: {renderText}</span>)
            }
        }
        console.log('quantityDetail===', voucherVM && voucherVM.quantityDetail)
        return (
            <Layout className="voucher-wraper-layer">
                <Layout className='voucher-wraper'>
                    <VoucherLefter onCollapse={this.onCollapse} />
                    {
                        this.voucherDefaultPosMode == 'voucher'
                            ?
                            <VoucherPattern
                                collapsed={collapsed}
                                settlementParams={settlementParams}
                                productParams={productParams}
                                memberParams={memberParams} />
                            :
                            <Content>
                                <Layout className='voucher-container-wrapper'>
                                    <Sider width={430} >
                                        <VoucherTpl collapsed={collapsed} memberParams={memberParams} />
                                    </Sider>
                                    <Layout className='voucher-right'>
                                        <Content className="product-container-wrapper">
                                            <Product {...productParams} />
                                        </Content>
                                        <Footer className="settlement">
                                            <Settlement {...settlementParams} />
                                        </Footer>
                                    </Layout>
                                </Layout>
                            </Content>
                    }
                </Layout>
                <Model />
                <Drawer {...memberParams} />
            </Layout>
        )
    }
}

export default RetailOrderView;